import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LoadingService } from '../../services/loading.service';
import { LayoutPreferenceService, BlogLayout } from '../../services/layout-preference.service';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.css'
})
export class SettingsComponent implements OnInit, OnDestroy {
  @Input() isOpen: boolean = false;
  @Output() close = new EventEmitter<void>();

  username: string = 'GS2057';
  email: string = 'thegauravsharma2057@gmail.com';
  currentDate: string = '';
  isRouted: boolean = false;
  activeMenuItem: string = 'App';

  layoutOptions: Array<{ value: BlogLayout; label: string; hint: string; icon: string }> = [
    { value: 'inline',          label: 'Inline expand', hint: 'Featured at top, others expand inline.',  icon: 'view_agenda'  },
    { value: 'drawer-featured', label: 'Side drawer',   hint: 'Featured at top, others open in a drawer.', icon: 'view_sidebar' },
    { value: 'drawer-grid',     label: 'Card grid',     hint: 'All posts as cards, drawer for detail.',    icon: 'grid_view'    },
  ];
  currentLayout: BlogLayout = 'inline';
  private layoutSub?: Subscription;

  constructor(
    private router: Router,
    private loadingService: LoadingService,
    private layoutPrefs: LayoutPreferenceService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    // Check if this component is routed to directly
    this.isRouted = this.router.url.includes('/settings');
    
    // If routed, always show the component
    if (this.isRouted) {
      this.isOpen = true;
    }
    
    // Get user info from localStorage if available
    const storedUser = localStorage.getItem('googleUser');
    if (storedUser) {
      const user = JSON.parse(storedUser);
      this.username = user.name?.split(' ')[0] || 'GS2057';
      this.email = user.email || 'thegauravsharma2057@gmail.com';
    }

    // Get current date and format it
    const now = new Date();
    this.currentDate = this.formatDate(now);
    
    // Mark the app as loaded to hide the loading spinner
    setTimeout(() => {
      this.loadingService.setSingleTreeLoaded();
      this.loadingService.setMainAreaLoaded();
      this.loadingService.setDetailsAreaLoaded();
    }, 300);

    this.layoutSub = this.layoutPrefs.layout$.subscribe(l => {
      this.currentLayout = l;
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.layoutSub?.unsubscribe();
  }

  setLayout(layout: BlogLayout): void {
    this.layoutPrefs.set(layout);
  }

  formatDate(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }

  closeSettings(): void {
    if (this.isRouted) {
      // Navigate back if this was opened as a route
      this.router.navigate(['/']);
    } else {
      // Just emit the close event if used as a dialog
      this.close.emit();
    }
  }

  setActiveMenuItem(item: string): void {
    this.activeMenuItem = item;
  }
} 